// extracted by mini-css-extract-plugin
export default {"recos":"a1-z","productCardOverride":"b1-z","rowHasBadge":"c1-z"};